import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import Banner from '../components/Banner';

import styles from './styles';
import '../styles.css';

/**
 * The Layout component, shared among pages.
 */
const BaseLayout = ({
  children,
  classes,
  className,
  footerClass = '',
  uid,
}) => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const rootClassName = cn(classes.root, className);

  return (
    <StaticQuery
      query={graphql`
        query BaseSiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              { name: 'description', content: 'Developer Economics' },
              { name: 'keywords', content: 'developer, economics' },
            ]}
            script={[
              {
                id: 'Cookiebot',
                src: 'https://consent.cookiebot.com/uc.js',
                'data-cbid': process.env.GATSBY_COOKIEBOT_ID,
                type: 'text/javascript',
                async: true,
              },
            ]}
          >
            <html lang="en" />
          </Helmet>
          <div className={rootClassName}>
            <CssBaseline />
            <Topbar
              className={classes.topbar}
              onMobileMenuClick={() => setOpenMobileMenu(true)}
            />
            <MobileMenu
              open={openMobileMenu}
              onClose={() => setOpenMobileMenu(false)}
            />
            <Grid container className={classes.grid}>
              <Banner uid={uid} />
              <Grid item xs={12}>
                {children}
              </Grid>
            </Grid>
            <Grid container className={classes.footer}>
              <Grid item xs={12}>
                <Footer className={footerClass} />
              </Grid>
            </Grid>
          </div>
        </>
      )}
    />
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape().isRequired,
};

export default withStyles(styles)(BaseLayout);
